<template>
  <v-card-actions class="cardAction">
    <v-spacer></v-spacer>
    <v-btn text @click.stop.prevent="cancel">Cancel</v-btn>
    <v-btn
      :loading="this.loading"
      :disabled="this.disabled"
      v-if="update"
      style="color: black"
      color="secondary"
      dark
      @click.stop.prevent="submit"
      >Update</v-btn
    >
    <v-btn
      :loading="this.loading"
      :disabled="this.disabled"
      v-else
      color="primary"
      :data-cy="`${this.name}SaveBtn`"
      @click.stop.prevent="submit"
      >Save</v-btn
    >
  </v-card-actions>
</template>

<script>
export default {
  props: {
    update: {
      default: false,
    },
    name: {
      default: "data-cy",
    },
    loading: {
      default: false,
    },
    disabled: {
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped></style>
